import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CAOModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Functional components of a computer', path: '/Ca-m1-s1' },
      { name: 'Registers and Register Files', path: '/Ca-m1-s2' },
      { name: 'Interconnection of components', path: '/Ca-m1-s3' },
      { name: 'IAS Computer function', path: '/Ca-m1-s4' },
      { name: 'VON Neumann Machine and Harvard Architecture', path: '/Ca-m1-s5' },
      { name: 'CISC and RISC Architectures', path: '/Ca-m1-s6' },
      { name: 'Summary', path: '/Ca-m1-s7' }

    ],

    'Module 2': [
      { name: 'Booth algorithm', path: '/Ca-m2-s1' },
      { name: 'Restoring and Non-restoring', path: '/Ca-m2-s2' },
      { name: 'Floating point representation', path: '/Ca-m2-s3' },
      { name: 'Summary', path: '/Ca-m2-s4' }
    ],
    'Module 3': [
      { name: 'Instruction sets and Instruction set formats', path: '/Ca-m3-s1' },
      { name: 'Memory Traffic Calculations', path: '/Ca-m3-s2' },
      { name: 'Addressing Modes', path: '/Ca-m3-s3' },
      { name: 'Phases of Instruction Cycle', path: '/Ca-m3-s4' },
      { name: 'Datapath and control unit', path: '/Ca-m3-s5' },
      { name: 'Performance metrics', path: '/Ca-m3-s6' },
      { name: 'Summary', path: '/Ca-m3-s7' }
    ],
    'Module 4': [
      { name: 'Memory systems hierarchy Characteristics', path: '/Ca-m4-s1' },
      { name: 'Byte storage methods', path: '/Ca-m4-s2' },
      { name: 'Conceptual view of memory cell', path: '/Ca-m4-s3' },
      { name: 'Memory Interleaving', path: '/Ca-m4-s4' },
      { name: 'Cache Management', path: '/Ca-m4-s5' },
      { name: 'Summary', path: '/Ca-m4-s6' }

    ],
    'Module 5': [
      { name: 'I/O fundamentals: handshaking, buffering ', path: '/Ca-m5-s1' },
      { name: 'Programmed I/O', path: '/Ca-m5-s2' },
      { name: 'Interrupt driven I/O', path: '/Ca-m5-s3' },
      { name: 'Direct Memory Access', path: '/Ca-m5-s4' },
      { name: 'Interrupt structures: Vectored and Prioritized ', path: '/Ca-m5-s5' },
      { name: 'Buses: Synchronous and asynchronous - Arbitration', path: '/Ca-m5-s6' },
      { name: 'Summary', path: '/Ca-m5-s7' }
    ],
    'Module 6': [
      { name: 'Solid state drivers', path: '/Ca-m6-s1' },
      { name: 'Electronic- magnetic and optical technologies ', path: '/Ca-m6-s2' },
      { name: 'RAID Levels  ', path: '/Ca-m6-s3' },
      { name: 'Summary', path: '/Ca-m6-s4' }
    ],
    'Module 7': [
      { name: 'Classification of models', path: '/Ca-m7-s1' },
      { name: 'Pipelining', path: '/Ca-m7-s2' },
      { name: 'Hazards', path: '/Ca-m7-s3' },
      { name: 'Superscalar architecture', path: '/Ca-m7-s4' },
      { name: 'Performance evaluation of parallel processors', path: '/Ca-m7-s5' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Computer Architecture and Organization</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CAOModules' }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CAOModules;
